import React, { Component, Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'components/AppRequest';
import withRouter from 'components/components/common/withRouter';
import { FACEBOOK } from 'components/common/constants/authConstants';
import { updateRegisterFields, setUserLogged } from 'components/actions/authActions';
import { connect } from 'react-redux';
import SignUpRedirectHelper from './utils/SignUpRedirectHelper';
import LocalStorageHelper from 'components/common/helpers/LocalStorageHelper';
import {
  createErrorNotification
} from 'components/actions/serviceActions';
import TransHelper from 'components/common/translations/TransHelper';
import originAxios from 'axios';

class FacebookAuth extends Component {

  transNotify = (key) => {
    return TransHelper.translate(this.props.locale, 'content.notifications.facebook.' + key);
  }

  componentDidMount() {
    var that = this;
    this.auth2;
    window.fbAsyncInit = function () {
      FB.init({
        appId: '413608359249010',
        cookie: true,
        xfbml: true,
        version: 'v3.2'

      });
      // FB.getLoginStatus(function(response) {
      //   that.statusChangeCallback(response);
      // });
      FB.AppEvents.logPageView();
    };

    (function (d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) { return; }
      js = d.createElement(s); js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
  }

  successCallback = (accessToken, profileData) => {
    var customerData = {
      token: accessToken,
      profile_id: profileData.id,
      name: profileData.name,
      email: profileData.email,
      type: FACEBOOK
    };
    this.props.updateRegisterFields(customerData);

    var params = {
      data: {
        token: accessToken,
        profile_id: profileData.id,
        type: FACEBOOK,
        customer: {
          name: profileData.name,
          email: profileData.email,
        }
      }
    }

    if (this.props.isRegister) {
      //register request
      var helper = new SignUpRedirectHelper(customerData);
      axios.post('/pwa/registration/check-social-account', params)
        .then(response => {
          originAxios.post('/set-logged');
          helper.accountCreatedAlready = true;
          LocalStorageHelper.saveToken(response.data.token);
          this.props.setUserLogged(response.data);
          TransHelper.redirect(this.props, helper.getRedirectPath());
        })
        .catch(err => {
          console.log("err", err.response)
          console.log("AUTH FAIL")
          TransHelper.redirect(this.props, helper.getRedirectPath());
        });
    } else {
      //login request
      axios.post('/pwa/security/login-via-facebook', params)
        .then(response => {
          originAxios.post('/set-logged');
          LocalStorageHelper.saveToken(response.data.token);
          this.props.setUserLogged(response.data);
          TransHelper.redirect(this.props, 'routes.url.dashboard');
        })
        .catch(err => {
          console.log(err)
          this.props.createErrorNotification({
            title: this.transNotify('error'),
            message: err.response.data.error
          });
        });
    }
  }

  loginFbAction = (event) => {
    var that = this;
    event.preventDefault();
    FB.login(function (response) {
      if (response.status === 'connected') {
        var accessToken = response.authResponse.accessToken;
        FB.api('/me', { fields: 'name, email' }, function (profileData) {
          that.successCallback(accessToken, profileData);
        });
      } else {
        console.log("fail", response)
      }
    }, {
        scope: 'public_profile,email',
        auth_type: 'reauthorize'
      });
  }

  render() {
    if (this.props.isRegister) {
      return (
        <a
          href=""
          className="button button--expand button--outline button--icon button--fb"
          onClick={this.loginFbAction}
        >
          <FontAwesomeIcon
            icon={['fab', 'facebook']}
            size="lg"
          />
          <span>Facebook</span>
        </a>
      );
    } else {
      return (
        <a
          onClick={this.loginFbAction}
          href=""
        >
          Facebook
        </a>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    locale: state.app.locale
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    { updateRegisterFields, setUserLogged, createErrorNotification }
  )(FacebookAuth));
